import {Component, EventEmitter, Input, OnInit, Output, ChangeDetectionStrategy} from '@angular/core';
import {MaterialStorage} from '../../material-management.model';
import {UntypedFormBuilder, UntypedFormGroup, Validators} from '@angular/forms';
import {MaterialManagementService} from '../../material-management.service';
import {AlertService} from '../../../../common/alert-service/alert.service';
import {NumberHelper} from '../../../../helper/number-helper';

@Component({
    selector: 'material-inventory-transfer-konsi-modal',
    templateUrl: './material-inventory-transfer-konsi-modal.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class MaterialInventoryTransferKonsiModalComponent implements OnInit {
  @Input() storage: MaterialStorage;
  @Input() isKonsi: Boolean;
  @Output() closeEmitter: EventEmitter<boolean> = new EventEmitter<boolean>();

  maxAmount: number;
  form: UntypedFormGroup;
  errors: { [key: string]: any } = {};
  lockSubmission = false;

  constructor(private fb: UntypedFormBuilder,
              private mmService: MaterialManagementService,
              private alertService: AlertService) {
  }

  ngOnInit(): void {
    this.maxAmount = this.isKonsi ? this.storage.amount_konsi : this.storage.amount_storage;
    const price = NumberHelper.saveParseFloat(this.storage.price);
    this.form = this.fb.group({
      transaction_type: [4],
      variation_id: [this.storage.variation_id],
      location: [this.storage.location],
      charge: [this.storage.charge],
      date_received: [this.storage.date_received],
      amount: [this.maxAmount, Validators.compose([Validators.min(0), Validators.max(this.maxAmount)])],
      konsi: [!this.isKonsi],
      note: [null],
      price: [price?.toLocaleString('de-DE').replace('.', ''), {emitEvent: false}],
      order_transaction_id: [this.storage.order_transaction_id, {emitEvent: false}],
    });
  }

  submit(): void {
    if (!this.lockSubmission) {
      this.errors = {};
      this.mmService.transferStock(this.storage.id, this.form.value).subscribe(() => {
        this.closeEmitter.emit(true);
      }, response => {
        switch (response.status) {
          case 400:
            if (response.error) {
              this.errors = response.error;
            }
            break;
          case 404:
            this.errors['obj.variation_id'] = [{msg: ['error.variation.not.found'], args: []}];
            break;
          default:
            this.alertService.add('danger', 'Unbekannter Fehler beim übertragen.');
        }

        this.lockSubmission = false;
      });
    }
  }

  dismiss(): void {
    this.closeEmitter.emit(false);
  }

}
